import { CopyFragment } from './hooks/getCopy';
import { WardrobeCopyFragment } from './hooks/getWardrobeCopy';

export const COPY = {
  inactiveBookmarkLabel: 'Save item',
  activeBookmarkLabel: 'Remove saved item',
  savedItemSuccessMessage: 'Saved. Hurry, it’s not reserved.',
  unsavedItemSuccessMessage: 'Your saved item has been removed.',
  feedbackUpdateSuccessMessage: 'Feedback saved',
  errorToastMessage: 'Something went wrong. Please try again.',
  pageTitle: 'Search results | Stitch Fix',
  fallbackDescription:
    'Styles that go with your search. Free shipping, returns & exchanges',
} as const;

export const defaultCopy: CopyFragment = {
  emptyResultsTextPrefix: '',
  emptyResultsTitle: '',
  outfitsCarouselTitle: '',
  resultsExplanationText: '',
  resultsForPrefix: '',
};

export const wardrobeDefaultCopy: WardrobeCopyFragment = {
  boughtItemsModuleTitle: '',
  boughtModuleEmptyStateHeading: '',
  boughtModuleEmptyStateSubheading: '',
  boughtModuleOutfitCarouselHeading: '',
  heading: '',
  savedModuleEmptyStateHeading: '',
  savedModuleEmptyStateSubheading: '',
  savedModuleOutfitCarouselHeading: '',
  savedOutfitsModuleEmptyStateHeading: '',
  savedOutfitsModuleEmptyStateSubheading: '',
  subheading: '',
  topItemsModuleEmptyStateHeading: '',
  topItemsModuleEmptyStateSubheading: '',
  topItemsModuleHeading: '',
};
